import { render, staticRenderFns } from "./BookmarkButton.vue?vue&type=template&id=0f4fb1bd&scoped=true"
import script from "./BookmarkButton.vue?vue&type=script&lang=ts"
export * from "./BookmarkButton.vue?vue&type=script&lang=ts"
import style0 from "./BookmarkButton.vue?vue&type=style&index=0&id=0f4fb1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fb1bd",
  null
  
)

export default component.exports